import React from 'react';

/** PlantContext for current session user. */

const PlantContext = React.createContext();

export default PlantContext;
